import { Observable } from 'rxjs';

import { CatalogObjectTypes, Group, PermAccessLevelString } from '@mirage-projects/cw-models';

export type NewGroup = Omit<Group, 'uid' | 'companyId' | 'acls'>;

export abstract class GroupService {
    abstract get(id: string): Observable<Group>;
    abstract getAll(): Observable<Group[]>;
    abstract new(group: NewGroup): Observable<Group>;
    abstract update(uid: Group['uid'], group: Partial<Omit<Group, 'Id'>>): Observable<Group>;
    abstract delete(id: string): Observable<any>;
    abstract addGroupUsers(id: string, userIds: { uid: string }[]): Observable<unknown>;
    abstract removeGroupUser(groupId: string, userId: string): Observable<unknown>;
    abstract addGroupACL(groupId: string, aclId: string): Observable<unknown>;
    abstract deleteGroupACL(groupId: string, aclId: string): Observable<unknown>;

    /**
     * Add group permission
     */
    abstract addGroupPermission(
        groupUid: string,
        objectId: number,
        objectType: CatalogObjectTypes,
        objEffect: PermAccessLevelString
    ): Observable<void>;

    /**
     * Delete group permission
     */
    abstract deleteGroupPermission(groupUid: string, objectId: number, objectType: CatalogObjectTypes): Observable<void>;
}
